// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"ResetPassword_resetPasswordForm__lA5Js","snackbar":"ResetPassword_snackbar__JCMPI","closeButton":"ResetPassword_closeButton__zetOV"};